import React, { useState, useEffect } from "react";
import { FiShoppingCart, FiUser, FiSearch, FiGrid, FiX, FiHeart,FiHome } from "react-icons/fi";
import { FaWhatsapp } from 'react-icons/fa'; // Updated imports
import CartModal from "./CartModal"
import { Link, useNavigate } from "react-router-dom";
import { GetCartCount } from "../Api/services/CartServices";
import Logo from "../assets/Black logo - no background.png"
import { useDispatch, useSelector } from "react-redux";
import { setCartCount } from "../slices/cart.slice";

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const dispatch = useDispatch();
  const cartItemCount = useSelector((state) => state.cart.cartItemCount);

  const fetchCartCount = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const response = await GetCartCount(token);
      setCartCount(response.data.count);
      dispatch(setCartCount(response.data.count));
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    const userProfile = localStorage.getItem('user');
    fetchCartCount();
    if (userProfile) {
      setProfileData(JSON.parse(userProfile));
    }
  }, []);

  const openCartModal = () => {
    setCartModalOpen(true); // Open the cart modal
  };


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen(dropdownOpen === menu ? null : menu);
  };

  const toggleProfileDropdown = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setProfileData(null);
    window.location.reload();
  };

  return (
    <div className="w-full bg-white shadow-sm">
      {/* Navbar Container */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Company Name */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-xl font-bold text-gray-800">
              <img src={Logo} className="w-24" />
            </Link>
          </div>

          {/* Center Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/shop" className="text-sm font-medium text-gray-700 hover:text-gray-900">SHOP</Link>
            <Link to="/shop" className="text-sm font-medium text-gray-700 hover:text-gray-900">DREAMY DRAPES</Link>
            <Link to="/" className="text-sm font-medium text-gray-700 hover:text-gray-900">HOME</Link>
            <Link to="/about" className="text-sm font-medium text-gray-700 hover:text-gray-900">ABOUT</Link>
            <Link to="/contact" className="text-sm font-medium text-gray-700 hover:text-gray-900">CONTACT</Link>
          </div>

          {/* Right Section */}
          <div className="hidden lg:flex items-center space-x-6">
            {localStorage.getItem("token") ? (
              <div className="relative">
                <button
                  onClick={openCartModal}
                  className="relative text-gray-600 hover:text-gray-900"
                >
                  <FiShoppingCart size={20} />
                  {(
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {cartItemCount}
                    </span>
                  )}
                </button>
              </div>
            ) : null}
            {/* Profile Section */}
            <div className="relative" onClick={toggleProfileDropdown}>
              <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-800">
                <FiUser size={20} />
              </button>
              {profileDropdownOpen && (
                <div className="absolute top-full right-0 mt-1 w-48 bg-white border rounded-md shadow-lg py-2 z-50">
                  {profileData ? (
                    <>
                      <div className="px-4 py-2 border-b">
                        <div className="font-medium">{profileData.name}</div>
                        <div className="font-medium">{profileData.email}</div>
                        <div onClick={handleLogout} className="text-sm text-gray-500 cursor-pointer">
                          Logout
                        </div>
                      </div>
                      <Link to="/cart" className="block px-4 py-2 hover:bg-gray-100">Cart</Link>
                      <Link to="/my-order" className="block px-4 py-2 hover:bg-gray-100">My Order</Link>
                      <Link to="/account" className="block px-4 py-2 hover:bg-gray-100">Account</Link>
                    </>
                  ) : (
                    <>
                      <Link to="/login" className="block px-4 py-2 hover:bg-gray-100">Login</Link>
                      <Link to="/signup" className="block px-4 py-2 hover:bg-gray-100">Sign Up</Link>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Mobile Controls */}
          <div className="lg:hidden flex items-center space-x-4">
            <button
              className="text-xl"
              onClick={toggleMenu}
              aria-label="Toggle Menu"
            >
              {"☰"}
            </button>
          </div>

        </div>
      </nav>

      {/* New Bottom Mobile Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t lg:hidden z-50">
        <div className="grid grid-cols-5 gap-1">
        <button 
          onClick={() => { navigate("/") }}
          className="flex flex-col items-center justify-center p-2 text-gray-600">
            <FiHome size={20} />
            <span className="text-xs mt-1">Home</span>
          </button>

          <button
            onClick={toggleMenu}
            className="flex flex-col items-center justify-center p-2 text-gray-600"
          >
            <FiGrid size={20} />
            <span className="text-xs mt-1">Categories</span>
          </button>

          <Link to="https://wa.me/9140816317" className="flex flex-col items-center justify-center p-2 text-gray-600">
            <FaWhatsapp size={20} />
            <span className="text-xs mt-1">WhatsApp</span>
          </Link>

          <button onClick={() => { navigate("/my-order") }}
            className="flex flex-col items-center justify-center p-2 text-gray-600">
            <FiUser size={20} />
            <span className="text-xs mt-1">Orders </span>
          </button>

          <button
            onClick={() => { navigate("/cart") }}
            className="flex flex-col items-center justify-center p-2 text-gray-600 relative"
          >
            <FiShoppingCart size={20} />
            {(
              <span className="absolute top-1 right-3 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                {cartItemCount}
              </span>
            )}
            <span className="text-xs mt-1">Cart</span>
          </button>
        </div>
      </div>

      {/* Updated Mobile Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-[90%] bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:hidden`}>
        <div className="flex flex-col h-full justify-between">
          <div className="p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Menu</h2>
              <button onClick={toggleMenu} className="p-2">
                <FiX size={24} />
              </button>
            </div>

            {/* User Profile Section in Sidebar */}
            <div className="mb-6 border-b pb-4">
              <div className="flex items-center space-x-2 mb-4">
                <FiUser size={20} />
                <span className="font-semibold">
                  {profileData ? profileData.name : 'Guest User'}
                </span>
              </div>
              {profileData ? (
                <>
                  <ul className="space-y-2">
                    <li><Link to="/cart" className="block py-2 hover:text-gray-500">Cart</Link></li>
                    <li><Link to="/my-order" className="block py-2 hover:text-gray-500">My Order</Link></li>
                    <li><Link to="/account" className="block py-2 hover:text-gray-500">Account</Link></li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="block py-2 hover:text-gray-500 text-red-500"
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </>
              ) : (
                <ul className="space-y-2">
                  <li><Link to="/login" className="block py-2 hover:text-gray-500">Login</Link></li>
                  <li><Link to="/signup" className="block py-2 hover:text-gray-500">Sign Up</Link></li>
                </ul>
              )}
            </div>

            {/* Navigation Items - Matching desktop version */}
            <ul className="space-y-4">
              <li>
                <Link to="/shop" className="block hover:text-gray-500">SHOP</Link>
              </li>
              <li>
                <Link to="/shop" className="block hover:text-gray-500">DREAMY DRAPES</Link>
              </li>
              <li>
                <Link to="/" className="block hover:text-gray-500">HOME</Link>
              </li>
              <li>
                <Link to="/about" className="block hover:text-gray-500">ABOUT</Link>
              </li>
              <li>
                <Link to="/contact" className="block hover:text-gray-500">CONTACT</Link>
              </li>
            </ul>
          </div>

          {/* Close Button */}
          <button
            className="p-4 bg-black text-white w-full text-center"
            onClick={toggleMenu}
          >
            Close
          </button>
        </div>
      </div>

      <div> {cartModalOpen && <CartModal closeCartModal={setCartModalOpen} />}</div>

    </div>
  );
};

export default Navbar;
